module.exports = __webpack_public_path__ + "img/animals_01_H.723b1a68.webp";